import '../components/zv/select-location/component';
// {
//     let optionsCache:{[name:string]: HTMLOptionElement[]} = {},
//         scope = document.getElementById('objects-filter');
//     scope.querySelectorAll('[data-linked-to]').forEach((element:HTMLElement)=>{
//         let select = element.querySelector('select'),
//             parentSelect = <HTMLSelectElement>scope.querySelector(`[name="${element.dataset.linkedTo}"] select`);
//         [...select.options].forEach((option:HTMLOptionElement)=>{
//             optionsCache[option.dataset.sectionId] = optionsCache[option.dataset.sectionId] || [];
//             optionsCache[option.dataset.sectionId].push(option);
//         });
//
//         if(parentSelect.value in this.optionsCache){
//             this.optionsCache[parentSelect.value].forEach((option)=>select.add(option));
//         }else{
//             let options:HTMLOptionElement[][] = Object.values(this.optionsCache),
//                 optionsFlat = options.reduce((acc:HTMLOptionElement[], options:HTMLOptionElement[]) => acc.concat(options), []);
//                 optionsFlat.sort((a, b)=>{
//                     if(a.textContent.toLowerCase() > b.textContent.toLowerCase()){
//                         return 1;
//                     }else if(a.textContent.toLowerCase() < b.textContent.toLowerCase()){
//                         return -1;
//                     }
//                     return 0;
//                 })
//                 .forEach((option)=>select.add(option));
//         }
//     });
// }